import React from "react";
import { ServicesFooter } from "./services-footer"

/**
 * Componente para mostrar el servicio Buyer Persona.
 *
 * @component
 * 
 */

export const BuyerPersona = (props) => {
    const [width, setWidth] = React.useState(window.innerWidth);
    const breakpoint = 620;

    React.useEffect(() => {
        /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
        window.addEventListener("resize", () => setWidth(window.innerWidth));

        /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    }, []);

  return (
    <div id="service-detail" className="text-center">
        <div className="col-md-8 col-md-offset-2 col-xs-12 section-title">
            <h2><span className="title">Servicios</span></h2>
        </div>       
        <div className="col-md-12 col-xs-12 imgMain paddingRightLeft0 text-right">
            <img alt="Buyer Persona" src={width < breakpoint ? "/img/services/BuyerPersona/ImagenPrincipal_mob.webp" : "/img/services/BuyerPersona/ImagenPrincipal.webp"}></img>
            <div className="text-left titleService">
                <p>Buyer <br></br>Persona</p>
            </div>
        </div>
        {width < breakpoint ? 
        <div className="col-md-12 col-xs-12 paddingRightLeft0">
            <div className="paddingTopBottom8">
                &nbsp;
            </div>
            <div className="paddingRightLeft0">
                <div className="col-md-12 col-xs-12 paddingRightLeft0">
                    <div className="col-md-5 col-xs-8 paddingRightLeft0">
                        <img alt="Buyer Persona" src="/img/services/BuyerPersona/BuyerPersona_img2.webp"></img>
                    </div>
                    <div className="col-md-7 col-xs-8 col-xs-offset-1 text-1">
                        <br></br>
                        <p>En nuestro enfoque de diseño de Buyer Persona, comprendemos que el éxito de cualquier estrategia de marketing se basa en conocer profundamente a tu público objetivo.
                            <br></br>
                            <br></br>
                            A través de un minucioso análisis de mercado y una investigación exhaustiva, creamos perfiles detallados de tus compradores ideales. Estos Buyer Personas te proporcionan una visión clara y precisa de quiénes son tus clientes potenciales, qué desean y cómo puedes llegar a ellos de manera efectiva.  </p>
                    </div>
                    <img alt="Buyer Persona" src="/img/services/CrecimientoExpo/CrecimientoExpo_img3_mob.webp"></img>
                </div>
                <div className="col-md-12 col-xs-12 paddingRightLeft0" style={{ paddingBottom: '64px' }}>
                    <div className="col-md-12 col-xs-12 text-2 paddingRightLeft0">
                    <div className="col-md-6 col-xs-10 col-xs-offset-1 text-2">
                            <p>Nuestro proceso de diseño de Buyer Persona te ayudará a optimizar tus esfuerzos de marketing y a generar conexiones significativas con tu audiencia.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        :
        <div className="col-md-12 paddingRightLeft0">
            <div className="paddingTopBottom16">
                &nbsp;
            </div>
            <div className="paddingTopBottom16">
                &nbsp;
            </div>
            <div className="paddingTopBottom16">
                &nbsp;
            </div>
            <div className="paddingRightLeft0">
                <div className="col-md-12 col-xs-12 paddingRightLeft30">
                    <div className="col-md-5 col-xs-12">
                        <img alt="Buyer Persona" src="/img/services/BuyerPersona/BuyerPersona_img2.webp"></img>
                    </div>
                    <div className="col-md-7 col-xs-12 text-1">
                        <p>En nuestro enfoque de diseño de Buyer Persona, comprendemos que el éxito de cualquier estrategia de marketing se basa en conocer profundamente a tu público objetivo.
                            <br></br>
                            <br></br>
                            A través de un minucioso análisis de mercado y una investigación exhaustiva, creamos perfiles detallados de tus compradores ideales. Estos Buyer Personas te proporcionan una visión clara y precisa de quiénes son tus clientes potenciales, qué desean y cómo puedes llegar a ellos de manera efectiva.  </p>
                    </div>
                </div>
                <div className="col-md-12 col-xs-12 padding paddingRightLeft0">
                <div className="col-md-12 background paddingRightLeft0" style={{ background: "url('../img/services/CrecimientoExpo/CrecimientoExpo_img3.webp')", backgroundSize: 'cover' }}>
                        <div className="col-md-6 col-xs-6 text-2 paddingRightLeft0">
                            <p>Nuestro proceso de diseño de Buyer Persona te ayudará a optimizar tus esfuerzos de marketing y a generar conexiones significativas con tu audiencia.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="paddingTopBottom8">
                &nbsp;
            </div>
            <div className="container-fluid padding-fluid" style={{ paddingBottom: '64px' }}>
                <ServicesFooter data={props.data} id={0} />
            </div>
        </div>
        }
    </div>
  );
};
